import { LensClient, development} from "@lens-protocol/client";

export const lensClient = new LensClient({
    environment: development
  });

